import { DeploymentBusinessUnitItemSchema } from "./deployment-business-unit-item";
import { DeploymentAccountItemSchema } from "./deployment-account-item";
import { DeploymentVendorItemSchema } from "./deployment-vendor-item";
import { DeploymentFuelBrandItemSchema } from "./deployment-fuel-brand-item";
import { DeploymentCashRegisterItemSchema } from "./deployment-cash-register-item";
import { z } from "zod";

export const DeploymentSubscriptionAssignDataSchema = z.object({
  NewBusinessUnit: z.boolean().optional(),
  Id: z.string().optional(),
  ProductId: z.string().optional(),
  ProductNumber: z.string().optional(),
  BusinessUnitIds: DeploymentBusinessUnitItemSchema.shape.Id.array(),

  BusinessUnitAccountId: DeploymentAccountItemSchema.shape.Id.optional(),
  BusinessUnitProductId: DeploymentCashRegisterItemSchema.shape.Id.optional(),
  BusinessUnitFuelBrandId: DeploymentFuelBrandItemSchema.shape.Id.optional(),
  BusinessUnitName: z.string().optional(),
  BusinessUnitPhoneNumber: z.string().optional(),
  BusinessUnitAddressLine1: z.string().optional(),
  BusinessUnitAddressCity: z.string().optional(),
  BusinessUnitAddressPostalCode: z.string().optional(),
  BusinessUnitAddressStateOrProvince: z.string().optional(),

  CashRegisterBrandId: z.string().optional(),
  CashRegisterModelId: z.string().optional(),

  VendorIds: DeploymentVendorItemSchema.shape.Id.array().optional(),
});

export type DeploymentSubscriptionAssignDataType = z.infer<
  typeof DeploymentSubscriptionAssignDataSchema
>;
